import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import HomePage from "../pages/HomePage/HomPage"; // Sửa lỗi typo
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import NavBar from "../components/NavBar/NavBar";
import "./manager-layout.css";
import Product from "../pages/Product/Product";
import ProductByCategory from "../pages/PoductByCategory/ProductByCategory"; // Sửa lỗi typo
import ProductDetail from "../pages/ProductDetail/ProductDetail";
import Support from "../pages/Supports/Support";
import New from "../pages/News/New";
import NewByCate from "../pages/NewsByCategory/NewByCate";
import NewDetail from "../pages/NewDetails/NewDetail";
import Service from "../pages/Service/Service";
import ServiceDetail from "../pages/ServiceDetail/ServiceDeatil"; // Sửa lỗi typo
import ProductManagement from "../pages/Manager/ProductManager/ProductManager";
import ProductDetailManager from "../pages/Manager/ProductDetailManager/ProductDetailManager";
import ProductCategoryManager from "../pages/Manager/ProductCategoryManager/ProductCategoryManager";
import NewCategoryManager from "../pages/Manager/NewCategoryManager/NewCategoryManager";
import ServiceCategoryManager from "../pages/Manager/ServiceCategoryManager/ServiceCategoryManager";
import ServiceManagement from "../pages/Manager/ServiceManager/ServiceManager";
import NewManagement from "../pages/Manager/NewManager/NewManager";
import ArchitectManagement from "../pages/Manager/ArchitectManager/ArchitectManager";
import ServiceDetailManager from "../pages/Manager/ServiceDetailManager/ServiceDetailManager";
import NewDetailManager from "../pages/Manager/NewDetailManager/NewDetailManager";
import SupportManager from "../pages/Manager/SupportManager/SupportManager";
import UserManager from "../pages/Manager/UserManger/UserManager"; // Sửa lỗi typo
import BannerManager from "../pages/Manager/BannerManager/BannerManager";
import Login from "../pages/Login/Login";
import ProtectedRoute from "../components/ProtectedRoute";

// Component to conditionally render Header
const HeaderWrapper = () => {
  const location = useLocation();
  const noHeaderRoutes = ["/", "/newdetail"];
  return noHeaderRoutes.includes(location.pathname) ||
    location.pathname.includes("/manager") ? null : (
    <Header />
  );
};

// Component to conditionally render Footer
const FooterWrapper = () => {
  const location = useLocation();
  return location.pathname.includes("/manager") ? null : <Footer />;
};

// Component to conditionally render Navbar
const NavbarWrapper = () => {
  const location = useLocation();
  return location.pathname.includes("/manager") ? <NavBar /> : null;
};

// Component to wrap manager routes with proper layout
const ManagerLayout = ({ children }) => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(() => {
    const path = location.pathname;
    if (path.includes("/products")) return "product";
    if (path.includes("/product-category")) return "product-category";
    if (path.includes("/services")) return "service";
    if (path.includes("/service-category")) return "service-category";
    if (path.includes("/news")) return "news";
    if (path.includes("/news-category")) return "news-category";
    if (path.includes("/banner")) return "banner";
    if (path.includes("/architects")) return "architects";
    if (path.includes("/users")) return "user";
    if (path.includes("/support")) return "support";
    return "product";
  });

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/products")) setActiveItem("product");
    else if (path.includes("/product-category"))
      setActiveItem("product-category");
    else if (path.includes("/services")) setActiveItem("service");
    else if (path.includes("/service-category"))
      setActiveItem("service-category");
    else if (path.includes("/news")) setActiveItem("news");
    else if (path.includes("/news-category")) setActiveItem("news-category");
    else if (path.includes("/banner")) setActiveItem("banner");
    else if (path.includes("/architects")) setActiveItem("architects");
    else if (path.includes("/users")) setActiveItem("user");
    else if (path.includes("/support")) setActiveItem("support");
  }, [location]);

  return (
    <div className="manager-layout">
      <NavBar activeItem={activeItem} />
      <div className="manager-content">{children}</div>
    </div>
  );
};

const UserRotes = () => {
  return (
    <Router>
      <div>
        <HeaderWrapper />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/product" element={<Product />} />
          <Route path="/noithat" element={<ProductByCategory />} />
          <Route path="/detail" element={<ProductDetail />} />
          <Route path="/support" element={<Support />} />
          <Route path="/new" element={<New />} />
          <Route path="/newbycate" element={<NewByCate />} />
          <Route path="/newdetail" element={<NewDetail />} />
          <Route path="/service" element={<Service />} />
          <Route path="/servicedetail" element={<ServiceDetail />} />
          <Route path="/login" element={<Login />} />

          {/* Protected manager routes */}
          <Route
            path="/manager/*"
            element={
              <ProtectedRoute>
                <Routes>
                  <Route
                    path="/products"
                    element={
                      <ManagerLayout>
                        <ProductManagement />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/products/detail/:id"
                    element={
                      <ManagerLayout>
                        <ProductDetailManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/product-category"
                    element={
                      <ManagerLayout>
                        <ProductCategoryManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/news-category"
                    element={
                      <ManagerLayout>
                        <NewCategoryManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/banner"
                    element={
                      <ManagerLayout>
                        <BannerManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/service-category"
                    element={
                      <ManagerLayout>
                        <ServiceCategoryManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/services"
                    element={
                      <ManagerLayout>
                        <ServiceManagement />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/servicedetailmanager/:id"
                    element={
                      <ManagerLayout>
                        <ServiceDetailManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/news"
                    element={
                      <ManagerLayout>
                        <NewManagement />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/newdetailmanager/:id"
                    element={
                      <ManagerLayout>
                        <NewDetailManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/architects"
                    element={
                      <ManagerLayout>
                        <ArchitectManagement />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/support"
                    element={
                      <ManagerLayout>
                        <SupportManager />
                      </ManagerLayout>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <ManagerLayout>
                        <UserManager />
                      </ManagerLayout>
                    }
                  />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
        <FooterWrapper />
      </div>
    </Router>
  );
};

export default UserRotes;
